import {Login} from '../../request/api/passpord';
import  {connect} from "../../utils/socket";


const ADMIN_TOKEN_KEY = 'SMHSWb_ADMIN_TOKEN';
const ADMIN_INFO_KEY = 'SMHSWb_ADMIN_INFO';

const state = {
    socketio: null,
    token: sessionStorage.getItem(ADMIN_TOKEN_KEY),
    info: JSON.parse(sessionStorage.getItem(ADMIN_INFO_KEY)),
};

const mutations = {
    SET_SOCKETIO: (state, io) => {
        state.socketio = io;
    },
    SET_TOKEN: (state, token) => {
        state.token = token;
        sessionStorage.setItem(ADMIN_TOKEN_KEY, token);
    },
    SET_INFO: (state, info) => {
        state.info = info;
        sessionStorage.setItem(ADMIN_INFO_KEY, JSON.stringify(info));
    },
};

const actions = {

    Login({commit}, userInfo) {
        const {username, password, guid, code} = userInfo;
        return new Promise((resolve, reject) => {
            Login({
                username: username,
                password: password,
                guid: guid,
                code: code,
            }).then(
                datas => {
                    commit("SET_TOKEN", datas.token);
                    commit("SET_INFO", datas.info);
                    resolve();
                }).catch(error => {
                reject(error);
            })
        })
    },

    setSocketIo({commit},io) {
        commit("SET_SOCKETIO", io);
    },

    //登出用户
    logout({commit}) {
        commit("SET_TOKEN", '');
        commit("SET_INFO", {});
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}

